import React from 'react';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  BsFillCalendar2Fill,
  BsTable,
  BsPersonSquare,
  BsClipboardPlus,
} from 'react-icons/bs';
import { MdOutlinePassword } from 'react-icons/md';
const Sidebar = () => {
  return (
    <div className="col-2 sidenav text-center" style={{ height: '100vh' }}>
      <Link className="p-2 mt-2 text-center navhome" to="/dashboard">
        <span>
          <BsFillCalendar2Fill />
        </span>
        {'  '}
        Dashboard
      </Link>
      <Link
        className="p-2 mt-2 text-center navhome"
        to="/dashboard/list-job-vacancy"
      >
        <span>
          <BsTable />
        </span>
        {'  '}
        Data Tabel
      </Link>
      <Link
        className="p-2 mt-2 text-center navhome"
        to="/dashboard/list-job-vacancy/form"
      >
        <span>
          <BsClipboardPlus />
        </span>
        {'  '}
        Form Data
      </Link>
      <Link className="p-2 mt-2 text-center navhome" to="/dashboard/profile">
        <span>
          <BsPersonSquare />
        </span>
        {'  '}
        Profile
      </Link>
      <Link
        className="p-2 mt-2 text-center navhome"
        to="/dashboard/change-password"
      >
        <span>
          <MdOutlinePassword />
        </span>
        {'  '}
        Ganti Password
      </Link>
    </div>
  );
};

export default Sidebar;
